module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-layout"
  }, [_c('div', {
    staticClass: "progress-wrap"
  }, _vm._l((_vm.progress), function(step, n) {
    return _c('div', {
      class: {
        'step': true, 'step-last': (n + 1) === _vm.progress.length
      }
    }, [_c('div', {
      class: {
        'point-wrap': true
      }
    }, [_c('div', {
      class: {
        point: true,
          'done-step': n <= _vm.indOfThisStep,
          'current-step': n === _vm.indOfThisStep,
      }
    }, [_c('p', [_vm._v(_vm._s(n + 1))])]), _vm._v(" "), _c('p', {
      staticClass: "point-title"
    }, [_vm._v(_vm._s(step.zh))])])])
  }), 0), _vm._v(" "), (_vm.currentSchedule && _vm.$store.state.currentApp.name === '醫囑取藥') ? _c('patient-info') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61940532","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/ProgressBar.vue
// module id = 1491
// module chunks = 1